import { Button, Image, UIText3 } from '@cian/ui-kit';

import * as styles from './styles.css';
import cn from 'clsx';
import { ETestIds } from '../../../constants/testIds';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectActionUrl, selectMasterButton } from '../../../selectors/landing';
import { IMasterButtonProps } from './types';
import { useAuthorized } from '../../../hooks/useAuthorized';
import { NBSP } from 'shared/constants/common';

export const FillApplicationButton: React.FC<IMasterButtonProps> = ({ currentButtonType }) => {
  const enabledButton = useSelector(selectMasterButton);
  const { authorizeAndRedirect } = useAuthorized();
  const masterButtonActionUrl = useSelector(selectActionUrl) as string;

  const handleClickOnMasterButton = useCallback(() => {
    authorizeAndRedirect({
      path: masterButtonActionUrl,
      analyticEventKey: currentButtonType,
    });
  }, [currentButtonType, masterButtonActionUrl]);

  return (
    <div
      className={cn(styles['wrapper'], enabledButton === currentButtonType && styles['active'])}
      data-testid={`king-btn-${currentButtonType}`}
    >
      <Button size="M" onClick={handleClickOnMasterButton}>
        Заполнить заявку на Циане
      </Button>
      <div className={styles.textContainer}>
        <UIText3 textAlign="center" color="text-secondary-default">
          Заявка{NBSP}— единая для всех банков.
        </UIText3>
        <UIText3 textAlign="center" color="text-secondary-default">
          Перед заполнением попросим авторизоваться.
        </UIText3>
      </div>
      <div className={cn(styles['img'])}>
        <Image
          src={'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/cat.png'}
          alt="background"
          preloader
          data-testid={ETestIds.PresentationImg}
        />
      </div>
    </div>
  );
};
